import * as fd from '@tensorflow-models/face-landmarks-detection';
import { setBackend, ready } from '@tensorflow/tfjs-core';
import '@tensorflow/tfjs-backend-webgl';

let model: fd.FaceLandmarksDetector | null = null;

export async function loadModel(setLoading: () => void) {
  if (!model) {
    await setBackend('webgl');
    await ready();

    model = await fd.createDetector(fd.SupportedModels.MediaPipeFaceMesh, {
      runtime: 'tfjs',
      refineLandmarks: true,
    });
    setLoading();
  }
}

function fileToImage(file: File): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = URL.createObjectURL(file);
  });
}

export async function validateFace(file: File, isEs?: boolean) {
  const image = await fileToImage(file);
  const predictions = await model!.estimateFaces(image);
  URL.revokeObjectURL(image.src);

  if (predictions.length === 0)
    return [
      isEs
        ? 'No pudimos identificar ningún rostro en tu foto. Prueba con otra imagen.'
        : 'We could not identify a face in your photo. Try  another image.',
    ];
  return [];
}
